import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import helper from '../util/helpers'

import { store } from '../store/store'
import DefaultRoutes from './subRoutes/default'
import MemberRoutes from './subRoutes/memberRouter'
import introRoutes from './subRoutes/introRouter'
import webchatRoutes from './subRoutes/webchatRouter'
import ticketRoutes from './subRoutes/ticketRouter'
import cafe24Routes from './subRoutes/cafe24Router'
import commerceCustomerRouter from './subRoutes/commerceCustomRouter'

import Nprogress from 'nprogress'
import Util from '@/util'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: () => import('@/components/layout'),
      redirect: '/dashboard',
      children: [...DefaultRoutes, ...MemberRoutes, ...introRoutes, ...webchatRoutes, ...ticketRoutes, ...cafe24Routes, ...commerceCustomerRouter]
    },
    // {
    //   path: '/operation',
    //   name: 'Operation Board',
    //   component: () => import('@/components/operation/operation_board')
    // },
    {
      path: '/todaySummary',
      name: 'Today 相談状況',
      component: () => import('@/components/todaySummaryLayout')
    },
    {
      path: '/chatbot/chatbot_edit',
      name: 'chatbot_edit',
      component: () => import('@/components/menus/chatbot/chatbot_edit')
    },
    {
      path: '/marketing/line/flexEdit',
      name: 'lineFlexEdit',
      component: () => import('@/components/menus/marketing/marketingFlexEdit')
    },
    {
      path: '/marketing/line/preview',
      name: 'marketingPreview',
      component: () => import('@/components/menus/marketing/marketingPreview')
    },
    {
      path: '/survey/:type',
      name: 'survey',
      component: () => import('@/components/menus/survey/survey'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/linesurvey/:type',
      name: 'linesurvey',
      component: () => import('@/components/menus/survey/line_survey'),
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/survey_management',
      name: 'アンケート管理',
      component: () => import('@/components/menus/survey/management/survey_management')
    },
    {
      path: '/uxGuide',
      name: 'uxGuide',
      component: () => import('@/components/uxGuide'),
      meta: {
        requiresAuth: false
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 30 },
        behavior: 'smooth'
      }
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  console.log('Navigating from:', from.path) // 이전 경로
  console.log('Navigating to:', to.path)
  Nprogress.start()
  const isValidToken = checkValidToken()
  try {
    if (isValidToken) {
      let agentMenus = JSON.parse(localStorage.getItem('agent-menus'))
      if ((to.path.toLowerCase() === '/member/login' || to.path.toLowerCase() === '/member/adminlogin') && Util.parseLoginToken().agentId && agentMenus) {
        next(agentMenus[0].path)
      }
      getAgentMenus(router, to, next).then(() => {
        checkIsPayment(router, to, next).then((data) => {
          next()
          if (data) {
            if (data.isFree) {
              localStorage.setItem('isPause', data.isPause)
              router.app.$nextTick(() => {
                router.app.$eventBus.$emit('DialogPopup', {
                  useDialog: true,
                  getBtnName: data.getBtnName,
                  messageHTML: data.messageHTML,
                  getButtonEvent: data.getButtonEvent
                })
              })
            } else {
              localStorage.setItem('isPause', false)
            }
          }
        })
      }).catch((path) => {
        if (to.meta.requiresAuth === false) {
          next()
        } else if (path) {
          next(path)
        }
      })
    } else if (to.meta.requiresAuth === false) {
      next()
    } else {
      const nextPath = store.getters.isAdministratorRole ? '/member/adminlogin' : '/member/login'
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('agent-menus')
      next(nextPath)
    }
  } catch (e) {
    console.log(e)
  }
})

router.afterEach((to, from) => {
  Nprogress.done()
})

const checkValidToken = () => {
  const now = helper.convertTimeToMomentType(helper.getCurrentUTCDateTimeAsFormatted())
  return !!localStorage.getItem('token') && now.isBefore(helper.convertTimeToMomentType(Util.parseLoginToken().expireTime))
}

let paths = []
let pathList = []
let pathActions = []
let pathIdList = []
const checkAgentMenus = (router, to, menus) => {
  return new Promise(function (resolve, reject) {
    if (store.getters.getCheckPaths.length === 0 || !localStorage.getItem('agent-menus')) {
      pathList = []
      pathActions = []
      paths = []
      pathIdList = []
      menus.forEach((d) => {
        if (d.children) {
          d.path = d.children[0].children[0].path
          pathList[d.id] = []
          d.children.forEach((o) => {
            o.children.forEach((c) => {
              pathList[d.id].push(c.path)
              pathActions[c.path] = c.actions
              paths.push(c.path)
              pathIdList.push({name: c.path, id: c.id})
              if (c.pages) {
                c.pages.forEach((p) => {
                  pathList[d.id].push(p.path)
                  pathActions[p.path] = c.actions
                  paths.push(p.path)
                  pathIdList.push({name: p.path, id: p.id})
                })
              }
            })
          })
        } else {
          pathList[d.id] = [d.path]
          pathActions[d.path] = d.actions
          paths.push(d.path)
          pathIdList.push({name: d.path, id: d.id})
        }
        if (d.pages) {
          d.pages.forEach((o) => {
            paths.push(o.path)
            pathIdList.push({name: o.path, id: o.id})
          })
        }
      })
      store.commit('setCheckPaths', pathList)
      store.commit('setPathActions', pathActions)
      store.commit('setPathIdList', pathIdList)
    }
    localStorage.setItem('agent-menus', JSON.stringify(menus))
    let toPath = to.path
    const ejectParam = (to.matched[0] && to.matched[0].path.split('/:')) ? to.matched[0].path.split('/:')[1] : null
    if (Object.keys(to.params).length > 0) {
      toPath = Util.pathReplace(to.params, toPath, ejectParam)
    }
    if (paths.indexOf(toPath) > -1) {
      store.commit('setNowPathId', toPath)
      resolve()
    } else {
      store.commit('setNowPathId', paths[0])
      reject(paths[0])
    }
  })
}

const getAgentMenus = (router, to, next) => {
  return new Promise(function (resolve, reject) {
    if (!localStorage.getItem('agent-menus')) {
      router.app.$http({
        method: 'GET',
        url: Util.parseLoginToken().admin ? '/api/agent/adminMenus' : `/api/agent/menus?brandId=${Util.parseLoginToken().agentMappingBrandViews.sort((s1, s2) => s1.brandId - s2.brandId)[0].brandId}`
      }).then((rs) => {
        let res = rs.data
        if (res.code === 0 && res.data && res.data.length > 0) {
          checkAgentMenus(router, to, res.data).then(() => {
            resolve()
          }).catch((path) => {
            reject(path)
          })
        } else {
          alert('まだ役割が付与されていません。 システム管理者に役割付与を確認した後、再度お試しください。 ')
          store.dispatch('setMiniSidebarLayout', false)
          store.dispatch('logout').then(() => {
            next('/member/login')
          })
        }
      })
    } else {
      checkAgentMenus(router, to, JSON.parse(localStorage.getItem('agent-menus'))).then(() => {
        resolve()
      }).catch((path) => {
        reject(path)
      })
    }
  })
}
const checkIsPayment = (router, to, next) => {
  return new Promise(function (resolve) {
    if (Util && !Util.parseLoginToken().admin) {
      let userData = Util.parseLoginToken()
      if (userData.billingBrandAgentView.planType === 'FREE') {
        let start = router.app.$moment(router.app.$moment(helper.printTimeStampYYYYMMDDFromDateTime(userData.billingBrandAgentView.billingStartDate)).format('YYYY-MM-DD'))
        let end = router.app.$moment(router.app.$moment(start).add(14, 'day').format('YYYY-MM-DD'))
        let now = router.app.$moment(router.app.$moment(new Date()).format('YYYY-MM-DD'))
        let duration = router.app.$moment.duration(end.diff(now)).asDays()
        let isPause = (duration <= 0)
        let lookInBrandResult = localStorage.getItem('lookInBrandResult')
        if (!isPause && to.path === '/dashboard') {
          resolve({
            isPause: isPause,
            isFree: true,
            messageHTML: `<dl class="txt"><dt>無料期間使用中です。</dt><dd>あと${duration}日です。</dd></dl>`,
            getBtnName: '確認',
            getButtonEvent: () => {}
          })
        } else if (isPause && to.path !== '/brand/plan' && !lookInBrandResult) {
          resolve({
            isPause: isPause,
            isFree: true,
            messageHTML: '<dl class="txt"><dt>無料期間終了</dt><dd>引き続きサービスを利用するにはプラン申請が必要です。</dd></dl>',
            getBtnName: 'プラン申請',
            getButtonEvent: () => {
              next('/brand/plan')
            }
          })
        }
      } else {
        resolve({
        })
      }
      resolve()
    } else {
      resolve()
    }
  })
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js